// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p,
h1,
h2,
h3,
h4,
span {
  margin: 0;
  padding: 0;
}

ion-col {
  padding: 0;
}

.wrapper {
  text-align: center;
  padding: 26px 28px 36px;
  color: var(--color-black);
}

.content-wrapper {
  height: 226px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.logo {
  height: 45px;
  width: 156px;
  margin-bottom: 3px;
}

.title {
  font-family: AppFontBoldAlt;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: -0.02em;
  text-align: center;
  vertical-align: middle;
  text-transform: capitalize;
  margin-bottom: 10px;
}

.subtitle {
  font-family: AppFont;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  text-wrap: balance;
  margin-bottom: 27px;
}

.button-wrapper {
  width: 90%;
}

.btn {
  width: 100%;
  height: 54px;
  outline: var(--outline-default);
  outline-offset: var(--outline-offset-default);
  background: var(--ion-color-primary);
  border-radius: var(--radius-default);
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn span {
  font-family: AppFont, sans-serif;
  color: #fff;
  font-size: 16px;
  line-height: 19.2px;
  letter-spacing: 0.01em;
}

ion-spinner {
  color: #fff;
}

.input-wrapper {
  margin: 0 auto;
  margin-bottom: 25px;
  width: 90%;
}

.label {
  position: relative;
  top: 9px;
  left: 17px;
  background: white;
  z-index: 2;
  font-family: SecondaryFontSemiBold;
  font-size: 11px;
  line-height: 20px;
  text-align: left;
  text-transform: capitalize;
}

.item {
  --padding-start: 17px;
  --background: #f3f3f3;
}
.item ion-input {
  font-family: AppFont;
  font-size: 14px;
  line-height: 120%;
  text-align: center;
  color: var(--color-black);
  text-align: center;
}
.item.input-error ion-input {
  color: var(--ion-color-danger);
}

.cross-btn {
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
  height: 16px;
  width: 16px;
  z-index: 1000;
}

.success-icon {
  height: 56px;
  width: 56px;
  margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/request-email/request-email.component.scss"],"names":[],"mappings":"AAAA;;;;;;EAMC,SAAA;EACA,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAIA;EACC,kBAAA;EACA,uBAAA;EACA,yBAAA;AADD;;AAGA;EACC,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,YAAA;EACA,YAAA;EACA,kBAAA;AAAD;;AAGA;EACC,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EAEA,mBAAA;AADD;;AAIA;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,mBAAA;AAFD;;AAKA;EACC,UAAA;AAFD;;AAKA;EACC,WAAA;EACA,YAAA;EACA,+BAAA;EACA,6CAAA;EACA,oCAAA;EACA,oCAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFD;AAIC;EACC,gCAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,sBAAA;AAFF;;AAMA;EACC,WAAA;AAHD;;AAMA;EACC,cAAA;EACA,mBAAA;EACA,UAAA;AAHD;;AAMA;EACC,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,UAAA;EACA,kCAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;AAHD;;AAMA;EACC,qBAAA;EACA,qBAAA;AAHD;AAKC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAHF;AAOE;EACC,8BAAA;AALH;;AAUA;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;AAPD;;AAUA;EACC,YAAA;EACA,WAAA;EACA,kBAAA;AAPD","sourcesContent":["p,\nh1,\nh2,\nh3,\nh4,\nspan {\n\tmargin: 0;\n\tpadding: 0;\n}\n\nion-col {\n\tpadding: 0;\n}\n\n$inline-padding: 28px;\n\n.wrapper {\n\ttext-align: center;\n\tpadding: 26px $inline-padding 36px;\n\tcolor: var(--color-black);\n}\n.content-wrapper {\n\theight: 226px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.logo {\n\theight: 45px;\n\twidth: 156px;\n\tmargin-bottom: 3px;\n}\n\n.title {\n\tfont-family: AppFontBoldAlt;\n\tfont-size: 20px;\n\tline-height: 120%;\n\tletter-spacing: -0.02em;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-transform: capitalize;\n\n\tmargin-bottom: 10px;\n}\n\n.subtitle {\n\tfont-family: AppFont;\n\tfont-size: 14px;\n\tline-height: 135%;\n\tletter-spacing: 0;\n\ttext-align: center;\n\tvertical-align: middle;\n\ttext-wrap: balance;\n\n\tmargin-bottom: 27px;\n}\n\n.button-wrapper {\n\twidth: 90%;\n}\n\n.btn {\n\twidth: 100%;\n\theight: 54px;\n\toutline: var(--outline-default);\n\toutline-offset: var(--outline-offset-default);\n\tbackground: var(--ion-color-primary);\n\tborder-radius: var(--radius-default);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\tspan {\n\t\tfont-family: AppFont, sans-serif;\n\t\tcolor: #fff;\n\t\tfont-size: 16px;\n\t\tline-height: 19.2px;\n\t\tletter-spacing: 0.01em;\n\t}\n}\n\nion-spinner {\n\tcolor: #fff;\n}\n\n.input-wrapper {\n\tmargin: 0 auto;\n\tmargin-bottom: 25px;\n\twidth: 90%;\n}\n\n.label {\n\tposition: relative;\n\ttop: 9px;\n\tleft: 17px;\n\tbackground: white;\n\tz-index: 2;\n\tfont-family: SecondaryFontSemiBold;\n\tfont-size: 11px;\n\tline-height: 20px;\n\ttext-align: left;\n\ttext-transform: capitalize;\n}\n\n.item {\n\t--padding-start: 17px;\n\t--background: #f3f3f3;\n\n\tion-input {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 120%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-align: center;\n\t}\n\n\t&.input-error {\n\t\tion-input {\n\t\t\tcolor: var(--ion-color-danger);\n\t\t}\n\t}\n}\n\n.cross-btn {\n\tcursor: pointer;\n\tposition: absolute;\n\ttop: 20px;\n\tright: 20px;\n\theight: 16px;\n\twidth: 16px;\n\tz-index: 1000;\n}\n\n.success-icon {\n\theight: 56px;\n\twidth: 56px;\n\tmargin-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
